import { createLoadableComponent, createModuleLoader } from '@mews/framework';

import { createViewLoadingError } from '../../components/common/createViewLoadingError';

import { moduleId } from './constants';

const loader = createModuleLoader({
    name: moduleId,
    load: async () => import(/* webpackChunkName: "confirmation" */ './module'),
    dependencies: [],
});

export const Confirmation = createLoadableComponent({
    loader,
    component: 'ConfirmationView',
    ...createViewLoadingError({}),
});
